module.exports = __webpack_public_path__ + "img/header-memoireRingsWhite.024e54e.jpg";